// extracted by mini-css-extract-plugin
export var appDescription = "appCard-module--appDescription--MPftL";
export var appIcon = "appCard-module--appIcon--rJUbe";
export var appName = "appCard-module--appName--+QF5-";
export var appNameAndDescription = "appCard-module--appNameAndDescription--0HJxe";
export var appStore = "appCard-module--appStore--oSSoS";
export var card = "appCard-module--card--BISmG";
export var googlePlay = "appCard-module--googlePlay--rU6RM";
export var storeLinks = "appCard-module--storeLinks--HZNnF";
export var upper = "appCard-module--upper--+mmYH";